
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component } from 'vue-property-decorator';
import WidgetMixins from '../../mixins/WidgetMixins';
import { mixins } from 'vue-class-component';
import AuthLayout, { IPanelRow } from './components/AuthLayout.vue';
import { brandName } from '@/utils/brand';

@Component({
  components: {
    AuthLayout,
  },
})
export default class SignUpOptions extends mixins(WidgetMixins) {
  get brandName(): string {
    return brandName();
  }

  option: string | null = null;
  error: string | null = null;

  panelRows: IPanelRow[] = [
    {
      icon: 'bolt',
      title: 'Get started in minutes',
      text: 'Sign up, verify your account and send your first message.',
    },
    {
      icon: 'group',
      title: 'Built for teams of any size',
      text: 'From solo developers to reseller businesses with sub-accounts.',
    },
    {
      icon: 'lock',
      title: 'Secure by default',
      text: 'Your account and contacts stay protected end to end.',
    },
  ];

  chosenOption(key: string): void {
    this.error = null;
    this.option = key;
  }

  nextPage(): void {
    if (!this.option) {
      this.error = `Choose an option`;
      return;
    }
    this.error = null;
    if (this.option === 'personal') {
      this.$router.push({
        name: 'accounts.signup.developer',
      });
    } else {
      this.$router.push({
        name: 'accounts.signup.business',
      });
    }
  }
}
